<template>
    <AgentSelectionComp></AgentSelectionComp>
  </template>
  <script>
  import AgentSelectionComp from "../../components/Auths/AgentSelection.vue";
  
  export default {
    name: "Agent Selection",
    components: { AgentSelectionComp },
    computed: {},
    mounted() {},
  };
  </script>
  